class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.mobileMenuEl = document.querySelector('.site-header__mobile-menu');
		this.updateHeaderHeightVar();
		this.setupEventHandlers();
	}

	setupEventHandlers() {
		// mobile menu button handler
		const btnMobileMenu = document.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}


		// Desktop Megamenus
		const btnMegaMenus = this.el.querySelectorAll('.megamenu-control');
		const megaMenus = this.el.querySelectorAll('.mega-menu-content');
		const megaMenuBg = document.querySelector('.mega-menu__background');
		const body = document.querySelector('body');
		const megaMenuItems = this.el.querySelectorAll('.menu-item.has-megamenu');
		const quickNav = document.querySelector('.quick-nav');

		btnMegaMenus.forEach((el) => {
			el.addEventListener('click', () => {
				const menuItem = el.parentElement;
				const currentMegamenu = el.nextElementSibling;

				megaMenus.forEach((menu) => {
					if(currentMegamenu != menu) {
						menu.classList.remove('active');
					}
				});

				megaMenuItems.forEach((item) => {
					if(menuItem != item) {
						item.classList.remove('active');
					}
				})

				menuItem.classList.toggle('active');
				currentMegamenu.classList.toggle('active');

				let isActive = false;

				megaMenus.forEach((menu) => {
					if(menu.classList.contains('active')) {
						isActive = true;
					}
				})

				if(isActive) {
					body.classList.add('no-scroll');
					megaMenuBg.classList.add('active');
					quickNav.classList.add('hidden');
				} else {
					body.classList.remove('no-scroll');
					megaMenuBg.classList.remove('active');
					quickNav.classList.remove('hidden');

				}

			});
		});

		megaMenuBg.addEventListener('click', () => {
			megaMenus.forEach((menu) => {
				menu.classList.remove('active');
			});

			megaMenuItems.forEach((item) => {
				item.classList.remove('active');
			});

			body.classList.remove('no-scroll');
			megaMenuBg.classList.remove('active');
			quickNav.classList.remove('hidden');

		});

		document.addEventListener('keydown', evt => {
			if (evt.key === 'Escape') {
				megaMenus.forEach((menu) => {
					menu.classList.remove('active');
				});

				megaMenuItems.forEach((item) => {
					item.classList.remove('active');
				});
				
				body.classList.remove('no-scroll');
				megaMenuBg.classList.remove('active');
				quickNav.classList.remove('hidden');

			}
		});

		//Mobile Menu Dropdowns
		const btnMobileMegaMenus = this.mobileMenuEl?.querySelectorAll('.megamenu-control') || [];
		const mobileMegaMenus = this.mobileMenuEl?.querySelectorAll('.mega-menu-wrapper') || [];

		btnMobileMegaMenus.forEach((btn) => {
			btn.addEventListener('click', () => {

				const currentMegamenu = btn.nextElementSibling;

				mobileMegaMenus.forEach((menu) => {
					if(currentMegamenu != menu) {
						menu.classList.remove('active');
					}
				});

				btnMobileMegaMenus.forEach((button) => {
					button.classList.remove('active');
				});

				currentMegamenu.classList.toggle('active');

				if(currentMegamenu.classList.contains('active')) {
					btn.classList.add('active');
				}
			})
		})

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());
	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}
}

export default SiteHeader;
